<template>

  <BasicLayout>
    <ItemPage :options="options" :searchData="searchData" :quickSearch="quickSearch" :items="items" @createClicked="createClicked">
      <template slot="headerbutton">
        <v-btn v-if="notificationsDisplayed === 'auto'" text outline small color="primary" @click="fetchAllNotifications">Show all</v-btn>
      </template>
    </ItemPage>
    <v-dialog v-model="createModalToggled" :persistent="true" :max-width="'800px'">
      <NotifCreator @close="closeCreateDialog"/>
    </v-dialog>
  </BasicLayout>

</template>

<script>

import BasicLayout from '@/layouts/BasicLayout'
import ItemPage from '@/components/common/ItemPage'
import NotifCreator from '@/components/NotifCreator'
import ItemID from '@/components/links/ItemID'
import NotifSwitchButton from '@/components/NotifSwitchButton'
import TranslatableInput from '@/components/forms/TranslatableInput'
import DateSelector from '@/components/common/DateSelector'
import TranslatableCell from '@/components/tables/TranslatableCell'
import { mapGetters } from 'vuex'
import JsonInput from '../components/forms/JsonInput.vue'

export default {
  name: 'Notifications',
  components: {
    BasicLayout,
    ItemPage,
    NotifCreator,
    TranslatableInput,
    DateSelector,
    TranslatableCell,
    JsonInput
  },
  data () {
    return {
      itemIDs: [],
      createModalToggled: false,
      notificationsDisplayed: 'auto',
      options: {
        title: 'Notifications',
        applyEdit: this.edit,
        // applyDelete: this.del,
        creatable: true,
        editable: true,
        deletable: false,
        columns: [
          {
            text: 'ID',
            value: 'id',
            displayComponent: ItemID,
            editable: false,
            searchable: false
          },
          {
            text: 'Label',
            value: 'label',
            editable: false,
            searchable: false

          },
          {
            text: 'Notify at',
            value: 'notifyAt',
            editable: true,
            searchable: false,
            editComponent: DateSelector
          },
          {
            text: 'Title',
            value: 'title',
            editable: true,
            searchable: false,
            editComponent: TranslatableInput,
            displayComponent: TranslatableCell
          },
          {
            text: 'Text',
            value: 'content',
            editable: true,
            searchable: false,
            warning: 'DO NOT MODIFY {{ VARIABLES }} YOU DON\'T KNOW WHAT YOU\'RE DOING !',
            displayComponent: TranslatableCell,
            editComponent: TranslatableInput
          },
          {
            text: 'Deeplink',
            value: 'data',
            editable: true,
            searchable: false,
            editComponent: JsonInput
          },
          {
            text: 'Enabled',
            value: 'disabled',
            displayComponent: NotifSwitchButton,
            editable: false,
            searchable: false
          }
        ]
      }
    }
  },
  methods: {
    searchData () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('fetchNotifications')
          .then(resp => {
            this.itemIDs = resp.items.map(i => i.id)
            resolve(resp.totalItems)
          })
          .catch(err => {
            console.error('Failed to load notifications: ', err)
            this.itemIDs = []
            reject(err)
          })
      })
    },
    fetchAllNotifications () {
      this.notificationsDisplayed = 'all'
      return new Promise((resolve, reject) => {
        this.$store.dispatch('fetchAllNotifications')
          .then(resp => {
            this.itemIDs = resp.items.map(i => i.id)
            resolve(resp.totalItems)
          })
          .catch(err => {
            console.error('Failed to load notifications: ', err)
            this.itemIDs = []
            reject(err)
          })
      })
    },
    edit (item) {
      return this.$store.dispatch('patchNotification', {
        id: item.id,
        patch: item
      })
    },
    createClicked () {
      this.createModalToggled = true
    },
    closeCreateDialog () {
      this.createModalToggled = false
    },
    quickSearch (data) {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('getNotification', {
          id: data
        }).then(resp => {
          this.itemIDs = resp.id
          resolve(1)
        })
          .catch(err => {
            console.error('Failed to load notification: ', err)
            reject(err)
          })
      })
    }
  },
  computed: {
    ...mapGetters(['notificationByIDs']),

    items () {
      return this.notificationByIDs(this.itemIDs)
    }
  },
  mounted () {
    this.$store.dispatch('getSports')
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/Notifications.vue